import styled from 'styled-components';

export const BalanceOnHandPastInfoContainerStyle = styled.div`
  .fkTuFL {
    max-height: 15em;
  }
`;
